var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLabresult(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 276 276",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 51V225C7 249.301 26.6995 269 51 269H225C249.301 269 269 249.301 269 225V51C269 26.6995 249.301 7 225 7H51C26.6995 7 7 26.6995 7 51Z",
    stroke: "#8E8E8E",
    strokeWidth: 14
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M61 195C61 192.239 63.2386 190 66 190H149C151.761 190 154 192.239 154 195V202C154 213.046 145.046 222 134 222H81C69.9543 222 61 213.046 61 202V195Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 166C123 174.837 115.837 182 107 182C98.1634 182 91 174.837 91 166C95 159.5 98.1634 142.5 107 142.5C115.837 142.5 118 156.5 123 166Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.5938,
    y: 124.214,
    width: 48.3337,
    height: 10.5217,
    rx: 5.26087,
    transform: "rotate(-30.9939 99.5938 124.214)",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.188,
    y: 110.932,
    width: 61.1245,
    height: 10.5217,
    rx: 5.26087,
    transform: "rotate(-121.475 191.188 110.932)",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 131,
    width: 51,
    height: 11,
    rx: 5.5,
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.527 109.432C124.114 103.751 125.953 96.3789 131.634 92.9661L162.78 74.2562L178.972 101.211L147.826 119.921C142.145 123.333 134.773 121.494 131.36 115.813L127.527 109.432Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.858 54.3923C217.545 48.6528 210.206 46.6863 204.466 50L173 68.1669L188.722 95.3981L220.188 77.2312C225.928 73.9175 227.894 66.5784 224.58 60.8389L220.858 54.3923Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173 133C166.373 133 161 138.373 161 145L161 161L193 161L193 145C193 138.373 187.627 133 181 133L173 133Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.838 221.603C187.465 221.603 192.838 216.23 192.838 209.603L192.838 170.689L161.394 170.689L161.394 209.603C161.394 216.23 166.767 221.603 173.394 221.603L180.838 221.603Z",
    fill: "#8E8E8E"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabresult);
export default __webpack_public_path__ + "static/media/labresult.dee3af3a7ddc145c94fc5eafce6d0972.svg";
export { ForwardRef as ReactComponent };